import { ButtonBase, type ButtonBaseProps } from "@mui/material";
import { NavLink, type To } from "react-router-dom";
import type { ComponentPropsWithoutRef } from "react";
import { styled } from "@mui/material/styles";
import clsx from "clsx";

/** Stable class name for hover-actions so parent can target it without Emotion component selector */
export const paneListItemHoverActionsClassName = "pane-list-item-hover-actions";

interface Props extends ButtonBaseProps {
  to: To;
}

export const PaneListButton = (props: Props) => {
  return (
    <StyledButtonBase
      focusRipple
      focusVisibleClassName="focus-visible"
      component={NavLink}
      to={props.to}
      className={props.className}
    >
      {props.children}
    </StyledButtonBase>
  );
};

const HoverActionsRoot = styled("div")`
  display: none;
  transition: 150ms all;
  opacity: 0;
`;

export const PaneListItemHoverActions = ({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof HoverActionsRoot>) => (
  <HoverActionsRoot className={clsx(paneListItemHoverActionsClassName, className)} {...props} />
);

const StyledButtonBase = styled(ButtonBase)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  height: 75px;
  width: 100%;
  padding: 0 17px;

  border-radius: 4px;
  background-color: #f1f1f1;
  color: #000000;
  font-weight: 500;

  &:hover .${paneListItemHoverActionsClassName} {
    visibility: visible;
    opacity: 1;
    display: flex;
  }

  > .MuiSvgIcon-root {
    fill: #000000;
  }

  &.active {
    background-color: #3fabff;
    color: white;

    .MuiSvgIcon-root {
      fill: white;
    }
  }
` as unknown as typeof ButtonBase
